import { $frontiersClibConfig } from "@frontiers-vue3/public-pages";

export default defineNuxtPlugin(() => {
  const { domain, spaceName, loopUrl, ssMainDomain, isDevMode } =
    useRuntimeConfig().public;

  $frontiersClibConfig.setConfig({
    isFrontiers:
      domain.includes("frontiers") && !domain.includes("partnerships"),
    tenantName: spaceName,
    mainDomain: domain,
    loopUrl: loopUrl,
    ssMainDomain: ssMainDomain,
    useWwwAbsoluteUrls: !isDevMode
  });
});
